export default __webpack_public_path__ + "static/media/wallet.c0372995.svg";